import * as React from "react"

import { inputFieldVariants, type InputFieldVariantProps } from "@/components/ui/field-variants"
import { cn } from "@/lib/utils"

type InputProps = React.ComponentProps<"input"> & InputFieldVariantProps

const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type, variant = "floating", placeholder, ...props },
  ref
) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(inputFieldVariants({ variant }), className)}
      placeholder={placeholder ?? (variant === "floating" ? " " : undefined)}
      {...props}
    />
  )
})

export { Input }

